<div
    #tooltip
    class="fixed z-50 rounded text-sm font-sans py-1 px-2 shadow-lg opacity-0 transition-opacity duration-300 pointer-events-none whitespace-nowrap"
    [class.opacity-100]="visible"
    [ngClass]="{
      'bg-black text-white': theme === 'dark',
      'bg-white text-secondary-900 border border-secondary-200': theme === 'light',
      '-translate-x-1/2': position === 'above' || position === 'below',
      '-translate-y-1/2': position === 'left' || position === 'right'
    }"
    [style.left.px]="left"
    [style.top.px]="top"
>
    <ng-container *ngIf="tooltipTemplate; else textContent">
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </ng-container>
    <ng-template #textContent>{{content}}</ng-template>
</div>